import poweroffice from "./PowerOfficeBusiness2CloudConnectorInitialisation";

const ClientConnectorInitialisations = {
  poweroffice
};

export default ClientConnectorInitialisations;
